function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.4171 2.80286H10.9171V0.582857C10.9171 0.26 10.6571 0 10.3343 0H0.582857C0.26 0 0 0.26 0 0.582857V10.6114C0 10.9343 0.26 11.1943 0.582857 11.1943H3.08286V13.4143C3.08286 13.7371 3.34286 13.9971 3.66571 13.9971H13.4171C13.74 13.9971 14 13.7371 14 13.4143V3.38571C14 3.06571 13.74 2.80286 13.4171 2.80286ZM1.16571 10.0286V1.16571H9.74857V2.80286H3.66571C3.34286 2.80286 3.08286 3.06286 3.08286 3.38571V10.0286H1.16571ZM12.8343 12.8343H4.24857V3.97143H12.8314V12.8343H12.8343Z",
  fill: "#979797"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M6.35143 6.95429H10.8029C11.1257 6.95429 11.3857 6.69429 11.3857 6.37143C11.3857 6.04857 11.1257 5.78857 10.8029 5.78857H6.35143C6.02857 5.78857 5.76857 6.04857 5.76857 6.37143C5.76857 6.69143 6.02857 6.95429 6.35143 6.95429Z",
  fill: "#979797"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M6.35143 11.0173H10.8029C11.1257 11.0173 11.3857 10.7573 11.3857 10.4344C11.3857 10.1116 11.1257 9.85156 10.8029 9.85156H6.35143C6.02857 9.85156 5.76857 10.1116 5.76857 10.4344C5.76857 10.7573 6.02857 11.0173 6.35143 11.0173Z",
  fill: "#979797"
});

var SvgCopyLink = function SvgCopyLink(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCopyLink, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/copyLink.bcada1a4.svg";
export { ForwardRef as ReactComponent };